import React from 'react';
import PropTypes from "prop-types";

import {Button} from 'reactstrap';

import Framework from "@beardeddevops/react.framework";
import {Objects, Parts} from "components";
import UniversalModalOverride from "components/UniversalModalOverride";
import Tooltip from "@material-ui/core/Tooltip";


export default class CheckoutCustomer extends React.Component {
	static propTypes = {
		object: PropTypes.object.isRequired,
		properties: PropTypes.object.isRequired,
		prefix: PropTypes.string,
		locations: PropTypes.array.isRequired,
		history: PropTypes.object.isRequired,
		afterCustomerSave: PropTypes.func.isRequired,
		shouldLoad: PropTypes.bool.isRequired,
		onTextUpdate: PropTypes.func.isRequired,
		onSelectUpdate: PropTypes.func.isRequired,
	};

	constructor(props) {
		super(props);

		this.state = {
			customerAddModalOpen: false,
			customerEditModalOpen: false,
		}
	}

	handleToggleCustomerAddModal = () => this.setState({customerAddModalOpen: !this.state.customerAddModalOpen})
	handleToggleCustomerEditModal = () => this.setState({customerEditModalOpen: !this.state.customerEditModalOpen})

	render() {

		/** @type {Checkouts_Object} object */
		let object = this.props.object;
		let {properties, shouldLoad, afterCustomerSave, onSelectUpdate, onTextUpdate} = this.props;
		let {customerAddModalOpen, customerEditModalOpen} = this.state;
		let prefix = typeof this.props.prefix !== 'undefined' ? this.props.prefix : 'customer_';
		return (
			<div>
				<div className={'form-group'}>
					<div className="row">
						<div className="col-3">
							<span className="input-label">Customer</span>
							<Framework.Elements.UniversalModal
								locations={this.props.locations}
								history={this.props.history}
								name={"Customer"}
								object={Objects.Customer}
								showModal={customerAddModalOpen}
								objectProps={{
									hideSave: true
								}}
								handleToggle={this.handleToggleCustomerAddModal}
								afterSave={afterCustomerSave}
								url={'customers'}
							/>
							<Framework.Elements.UniversalModal
								locations={this.props.locations}
								history={this.props.history}
								id={object.customer}
								name={"Customer"}
								object={Objects.Customer}
								objectProps={{
									object: object.customers,
									hideSave: true
								}}
								showModal={customerEditModalOpen}
								handleToggle={this.handleToggleCustomerEditModal}
								afterSave={afterCustomerSave}
								size={"xl"}
								url={'customers'}
							/>
						</div>
						<div className="col-9 d-flex">
							<Button data-id={'add-customer'} onClick={this.handleToggleCustomerAddModal} className={"select-add"}
							        size={"sm"} outline color="primary">
								<i className={"fa fa-plus"}/>
							</Button>
							{object.customer &&
								<Button data-id={'edit-customer'} onClick={this.handleToggleCustomerEditModal} className={"select-add"}
								        size={"sm"} outline color="green-meadow">
									<i className={"fa fa-pencil"}/>
								</Button>}
							{object.customer &&
								<Tooltip title="To Customer" aria-label="To customer">

									<Button
										className={"select-add"}
										size={"sm"} outline color="secondary">
										<a href={'/customers/' + object.customer} target={"_blank"}>
											<i className={"fa fa-id-card-o"}/>
										</a>
									</Button>

								</Tooltip>}
							<div className={'flex-grow-1'} data-id={'my-customer'}>
								<Framework.Elements.Select
									shouldLoad={shouldLoad}
									update={onSelectUpdate}
									property={properties.customer}
									value={object.customer}
									error={object.customer_error}
									object={object.customers}
									text={'name'}
									//textHelper={'address/number'}
									sort={'name'}
									nullable={true}
								/>
							</div>
						</div>
					</div>
				</div>

				<Objects.Customer
					id={object.customer ?? null}
					properties={properties}
					onTextUpdate={onTextUpdate}
					prefix={prefix}
					disableFields={true}
					noDelete={false}
					hideSave={true}
				/>

			</div>
		);
	}
}

